import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  CHIP_SIZE,
  CHIP_TYPE,
  SHOW_COMPLETED_TASK_BY_DATE,
  SHOW_COMPLETED_TASK_FILTER_NAME,
  SHOW_TASK_GROUPING_TYPE,
  TASK_LIST_TYPE
} from '../../../global/constants';
import { updateTaskFilterGrouping } from '../../../helpers/common';
import { completedTaskMenu } from '../../../global/row';
import { AccountingData } from '../../../hooks/accounting/useAccountingData';
import { Dropdown, DropdownItem } from '../../dropdown';
import Chip from '../../chipComponent';
import SwitchInput from '../../input/switchInput';
import {
  ChipSection, Data, DropText, GroupDiv, Properties, PropertiesHeading, TaskDrop, TaskFilterDiv
} from '../styles';
import ChipMenuTrigger from './ChipMenuTrigger';

interface TaskFilterOptionsProps {
  accounting: AccountingData;
}

const TaskFilterOptions: React.FC<TaskFilterOptionsProps> = observer(({ accounting }) => {
  const {
    currentProject,
    getDisplayProperties,
    handleDisplayPropertyToggle,
    handleTaskCompletedByRecency,
    menus,
    onChangeCompletedTaskViewDate,
    taskFilter,
    toggleTaskFilter
  } = accounting;

  return (
    <TaskFilterDiv>
      {currentProject &&
        updateTaskFilterGrouping(currentProject) === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS && (
          <TaskDrop isTaskList>
            <Data>
              <GroupDiv>
                <DropText>Task completed by recency</DropText>
              </GroupDiv>
              <SwitchInput
                checked={taskFilter?.showRecentlyCompletedTask}
                onChange={() => handleTaskCompletedByRecency(!taskFilter?.showRecentlyCompletedTask)}
              />
            </Data>
            {taskFilter?.taskViewType !== TASK_LIST_TYPE.CALENDAR_VIEW && (
              <Data>
                <GroupDiv>
                  <DropText>Completed tasks</DropText>
                </GroupDiv>
                <Dropdown
                  modalTitle='Completed tasks'
                  content={
                    <ChipMenuTrigger
                      title={
                        SHOW_COMPLETED_TASK_FILTER_NAME[
                          taskFilter?.showCompletedTaskByFilter || SHOW_COMPLETED_TASK_BY_DATE.LAST_MONTH
                        ]
                      }
                      isOpen={menus.isOpenCompletedTaskDropdown}
                      onClick={() => menus.setIsOpenCompletedTaskDropdown(!menus.isOpenCompletedTaskDropdown)}
                    />
                  }
                  onOutsideClick={() => menus.setIsOpenCompletedTaskDropdown(false)}>
                  {completedTaskMenu.map((item) => (
                    <DropdownItem
                      key={item.key}
                      label={item.label}
                      onClick={() => onChangeCompletedTaskViewDate(item.key)}
                      isActive={taskFilter?.showCompletedTaskByFilter === item.key}
                    />
                  ))}
                </Dropdown>
              </Data>
            )}
          </TaskDrop>
        )}
      <TaskDrop isTaskList>
        <Data>
          <GroupDiv>
            <DropText>Show sub-tasks</DropText>
          </GroupDiv>
          <SwitchInput checked={taskFilter?.showSubTask} onChange={() => toggleTaskFilter('showSubTask')} />
        </Data>
        {taskFilter?.taskViewType !== TASK_LIST_TYPE.CALENDAR_VIEW && (
          <Data>
            <GroupDiv>
              <DropText>Show empty groups</DropText>
            </GroupDiv>
            <SwitchInput checked={taskFilter?.showEmptyGroup} onChange={() => toggleTaskFilter('showEmptyGroup')} />
          </Data>
        )}
      </TaskDrop>
      <Properties>
        <PropertiesHeading>Display properties</PropertiesHeading>
        <ChipSection>
          {getDisplayProperties().map((property) => {
            const filter = currentProject?.displayPropertiesFilterWithFirebase as Record<string, boolean> | undefined;
            const isActive = filter?.[property] !== false;
            return (
              <Chip
                variant={isActive ? CHIP_TYPE.FILL : CHIP_TYPE.FILL_WITHOUT_BORDER}
                size={CHIP_SIZE.SMALL}
                key={property}
                title={property}
                isActive={isActive}
                className={isActive ? 'task-filter-chip-active' : ''}
                onClick={() => handleDisplayPropertyToggle(property)}
                textColorType='secondary'
              />
            );
          })}
        </ChipSection>
      </Properties>
    </TaskFilterDiv>
  );
});

export default TaskFilterOptions;
